
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefoasis/privacy-policy",
      function () {
        return require("private-next-pages/debtreliefoasis/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefoasis/privacy-policy"])
      });
    }
  